/** Customer wording for Bring Over Keep vs Improve. No internal jargon. */

export const IMPROVE = 'improve';
export const KEEP = 'keep';

export const KEEP_TITLE = 'Keep this layout';
export const IMPROVE_TITLE = 'Redesign it';

export const KEEP_SUMMARY_AVAILABLE =
  "We'll bring your current pages over so you can edit that design.";
export const KEEP_SUMMARY_UNAVAILABLE =
  'Keeping this layout as editable pages is not available yet. You can preview the current site. Redesign still builds a new site from the words, photos, and products we read.';
export const IMPROVE_SUMMARY =
  "We'll build a new site from the words, photos, and products we read — not a copy of the old layout. This is the choice. The button below starts the build.";

export function normalizeImportFinish(raw) {
  const text = String(raw || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (['keep', 'keep_layout', 'keep_design', 'keep_this_layout'].includes(text)) {
    return KEEP;
  }
  return IMPROVE;
}
